import React from "react";
import { Transition, Dialog } from "@headlessui/react";
import moment from "moment";

const ModalNotificationUpdate = ({ isOpen, onClose, item }) => {
  const cancelButtonRef = React.useRef(null);

  return (
    <Transition.Root show={isOpen} as={React.Fragment}>
      <Dialog
        as="div"
        className="relative z-50"
        initialFocus={cancelButtonRef}
        onClose={onClose}
      >
        <Transition.Child
          as={React.Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-start justify-center p-4">
            <Transition.Child
              as={React.Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white shadow-xl transition-al w-full lg:w-1/2">
                <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                  <div className="flex justify-between sm:ml-4 h-fit">
                    <Dialog.Title as="h3" className=" text-gray-900 w-full">
                      <div className="flex justify-between items-center">
                        <div className="font-semibold text-2xl leading-6">
                          {item.title}
                        </div>
                        <span className="mr-4">
                          {moment(item.created_at).format(
                            "DD MMMM YYYY, HH:mm:ss"
                          )}
                        </span>
                      </div>
                    </Dialog.Title>
                    <button
                      type="button"
                      className=" bg-gray-300 px-3 py-2 text-sm font-semibold text-black shadow-sm hover:bg-gray-400"
                      onClick={onClose}
                    >
                      X
                    </button>
                  </div>
                  <div className="sm:flex sm:items-start">
                    <div className="mt-3 sm:ml-4 sm:mt-0">
                      {item.message && (
                        <div
                          className="mt-2 ck-editor-content"
                          dangerouslySetInnerHTML={{ __html: item.message }}
                        ></div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                  <button
                    type="button"
                    className="inline-flex w-full justify-center rounded-md bg-gray-300 px-3 py-2 text-sm font-semibold text-black shadow-sm hover:bg-gray-400 sm:ml-3 sm:w-auto"
                    onClick={onClose}
                  >
                    Close
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default ModalNotificationUpdate;
